import React, { useState, useEffect } from 'react';
import axios from 'axios';

import '../components/UploadSection.css'

const UploadSection = ({uploadDisabled=false, uploadState, keyId, name, initialData, uploadLabel, uploadUrl, setUploadResult, clearOnSuccess=false}) => {
  
  const [file, setFile] = useState(initialData);
  const [preview, setPreview] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [filesize, setFilesize] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStateClass, setUploadStateClass] = useState('UploadStateUnprocessed');

  useEffect( () => {
    const changeTextClass = () => {
      if(uploadState === "unprocessed") {
        setUploadStateClass("UploadStateUnprocessed");
      }
      else if (uploadState === "processing") {
        setUploadStateClass("UploadStateProcessing");
      }
      else if (uploadState === "processed") {
        setUploadStateClass("UploadStateProcessed");
      }
      else {
        setUploadStateClass("Hidden");
      }
    };

    changeTextClass();
  }, [uploadState])
  
  const buttonsDisabled = () => {
    return isUploading;
  }

  const imgFormats = [".jpg", ".jpeg", ".gif", ".svg", ".png", ".tiff", ".webp", ".bmp"];
  const vidFormats = {
    ".m3u8":  "application/x-mpegURL", 
    ".mp4":   "video/mp4", 
    ".mov":   "video/quicktime", 
    ".3gp":   "video/3gpp", 
    ".avi":   "video/x-msvideo", 
    ".wmv":   "video/x-ms-wmv", 
    ".mpeg":  "video/mpeg",
    ".flv":   "video/x-flv"
  };

  const isImage = (filename) => {
    if(filename !== null) {
      for(let format of imgFormats) {
        if(filename.endsWith(format) || filename.startsWith("data:image/")) {
          return true;
        }
      }
    }
    return false;
  }

  const getPreviewElem = (filename) => {
    if(filename !== null) {
      for(let format of imgFormats) {
        if(filename.endsWith(format) || filename.startsWith("data:image/")) {
          return <img src={filename} className="UploadPreviewImage" alt={filename} />;
        }
      }

      for(let format of Object.keys(vidFormats)) {
        if(filename.endsWith(format)) {
          return <video src={filename} className="UploadPreviewVideo" alt="Preview Video" width={250} type={vidFormats[format]}/>;
        }
      }

      if (filename.length > 0) {
        return <p>{filename}</p>;
      }
    }
    return 'No file selected';
  }

  const handleFileChange = (event) => {
    const f = event.target.files;
    if (f !== null && f !== undefined && f.length > 0) {      
      if(isImage(f[0].name)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreview(e.target.result);
        };
        reader.readAsDataURL(f[0]);
      }
      setFile(f[0]);
      setPreview(`${f[0].name}`);
      setFilesize(`${(f[0].size / 1000).toFixed(2)}KB`);
    } 
    else {
      setFile(null);
      setPreview('');
      setFilesize('');
    }
  };

  const clearFileArea = () => {
    setImagePreview(null);
    setFile(null);
    setPreview('');
  }
  
  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      setUploadResult(false, 'Please select a file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsUploading(true);

      const token = localStorage.getItem('token');
      if (token) {
        const response = await axios.put(uploadUrl, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        setUploadResult(true, response.data.status);
      }
    } catch (error) {
      setUploadResult(false, error.response?.data?.detail || error.message);
    } finally {
      setIsUploading(false);
      if(clearOnSuccess) {
        setFile(null);
        setPreview('');
        setImagePreview(null);
        setFilesize('');
      }
    }
  };

  const displayPreview = () => {
    if (imagePreview)
      return getPreviewElem(imagePreview);

    if(initialData)
      return getPreviewElem(initialData);

    if(preview && preview.length > 0)
      return preview;

    return 'None';
  }

  return (
    <div>
      <h4>{name}</h4>
      <h4 className={uploadStateClass}>{uploadState}</h4>
    <div className="UploadSection">

      {displayPreview()}
      <span className="UploadGroup">
        <div>
          { buttonsDisabled() ? <></>
          : 
          <div>
          <input type="file" id={keyId} onChange={handleFileChange} className="UploadInput"/>
          <label htmlFor={keyId} className="UploadLabel">
            {uploadLabel}
          </label>
          </div>
          }
          {preview && preview.length > 0 && 
          <>
          <span className="HorizontalGroup">
            <p className="UploadFilename">{preview} ({filesize})</p>
            <button className="CancelButton" onClick={clearFileArea} disabled={buttonsDisabled()}>✖</button>
          </span>
          { isUploading ? 
            <span><div className="LoadingSpinner">⧖</div> Uploading...</span> :
            <button disabled={uploadDisabled} onClick={handleUpload} className="StandardButton">Upload</button>
          }
          </>}
        </div>
      </span>
    </div>
    </div>
  );
}

export default UploadSection;
